import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { fetchTodayPicks } from "../../lib/api";
import { SectionHeader } from "./SectionHeader";
import { PickCard } from "./PickCard";

const Skeleton = () => (
  <div className="bg-card border border-border rounded-2xl overflow-hidden animate-pulse">
    <div className="h-32 sm:h-36 bg-secondary/60" />
    <div className="p-3.5 space-y-2">
      <div className="h-3 bg-secondary/60 rounded w-2/3" />
      <div className="h-3 bg-secondary/40 rounded w-full" />
      <div className="h-3 bg-secondary/40 rounded w-3/4" />
    </div>
  </div>
);

export const TodayPicks = () => {
  const [picks, setPicks] = useState(null);

  useEffect(() => {
    fetchTodayPicks(6).then(setPicks).catch(() => setPicks([]));
  }, []);

  if (picks && picks.length === 0) return null;

  return (
    <section data-testid="home-today-picks" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={Sparkles}
        eyebrow="Today's AI picks"
        title="Worth a look right now"
      />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {(picks || Array.from({ length: 6 })).map((p, i) =>
          p ? <PickCard key={p.slug || i} pick={p} /> : <Skeleton key={i} />,
        )}
      </div>
    </section>
  );
};

export default TodayPicks;
